module.exports = __webpack_public_path__ + "static/media/16.c68d7dd6.jpeg";